<template>
    <div :style=" 'width:'+width+'; height:'+ height +';'" class="btnplus" @click="btnclick">
        <span class="plusicon">+</span><span>新增</span>
    </div>
</template>
<script>
export default {
    props:{
        width: {
            type: String,
            default:()=>{
                return '70px'
            }
        },
        height: {
            type: String,
            default:()=>{
                return '30px'
            }
        }
    },
    data(){
        return{

        }
    },
    methods:{
        btnclick(){
            this.$emit('click')
        }
    }
}
</script>
<style lang="less" scoped>
   .btnplus{
       height: 30px;
       background-color: #36B374;
       color: white;
       font-size:14px;
       font-family:PingFangSC-Medium,PingFang SC;
       font-weight:500;
       color:rgba(255,255,255,1);
       line-height:30px;
       text-align: center;
       .plusicon{
           margin-right: 3px;
       }
   }
</style>